<!--
Copyright ThreatBlockr Inc 2023
Created by ejohnson on 12/6/23

// https://github.com/mengxiong10/vue2-datepicker.git
-->
<template>

  <v-tooltip v-if="showTooltip"
             top>

    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs"
           v-on="on">
        <bs-base-datetime-picker v-model="localValue"
                                 :items="items"
                                 :datetime-property="datetimeProperty"

                                 range
                                 :placeholder=computedPlaceholder
                                 range-separator=" to "

                                 v-bind="$attrs"
                                 @change="rangePickerDidChange"
                                 v-on="on"/>
      </div>
    </template>
    <div class="">
      {{ computedPlaceholder }}
    </div>
  </v-tooltip>

  <bs-base-datetime-picker v-else
                           v-model="localValue"
                           :items="items"
                           :datetime-property="datetimeProperty"

                           class="discriminator bs-table-daterange"
                           :confirm="true"
                           :inline="false"
                           :separate-date="true"
                           :clearable="true"
                           :sticky="false"
                           :text-field-props="{ dense: true }"
                           hide-details="auto"
                           placeholder="All Dates"
                           range

                           range-separator=" to "
                           v-bind="$attrs"

                           @change="rangePickerDidChange"
                           v-on:click.native.stop=""
  />

</template>

<script>
  // https://github.com/mengxiong10/vue2-datepicker/issues/671
  // https://github.com/mengxiong10/vue2-datepicker/issues/584
  // https://github.com/mengxiong10/vue2-datepicker/issues/616
  // https://github.com/mengxiong10/vue2-datepicker/issues/457 https://codesandbox.io/p/sandbox/open-time-panel-8wm3g     detect click date vs time

  import 'vue2-datepicker/index.css'

  import StickyDiscriminatorMixin from '@/mixins/StickyDiscriminatorMixin.js'
  import { compact, first, last, orderBy } from 'lodash'
  import BSDatetimeRangePickerMixin from '@/mixins/BSDatetimeRangePickerMixin.js'
  import helpers from '@/helpers/helpers.js'
  import BSBaseDatetimePicker from '@/views/unexpectedBlocks/BSBaseDatetimePicker.vue'

  export default {
    inheritAttrs: false,
    name: 'BsTableDatetimeRangePicker',
    props: {
      // https://vuejs.org/guide/components/props.html#prop-validation
      datetimeProperty: {
        default: 'datetime',
      },
      showTooltip: {
        type: Boolean,
        default: false,
      },
      debug: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Array,
        default: function() {
          return []
        },
      },
      items: {
        type: Array,
        required: false,
        default(rawProps) {
          return []
        },
      },
      placeholder: {
        type: String,
        default: 'Select Date Range',
      },
      sticky: {
        type: Boolean,
        default: false,
      },
      stickyModelPathArray: {
        type: Array,
        // Object or array defaults must be returned from
        // a factory function. The function receives the raw
        // props received by the component as the argument.
        required: false,
        default(rawProps) {
          return [ 'datetimeRange' ]
        },
      },

      loading: {
        type: Boolean,
        default: false,
      },

    },
    data() {
      return {
        viewType: undefined,
        showTimePanel: false,
        namespace: 'discriminators',
        datetimeArray: null,
      }
    },
    components: {
      'bs-base-datetime-picker': BSBaseDatetimePicker,
    },
    mixins: [
      StickyDiscriminatorMixin,
      BSDatetimeRangePickerMixin,
    ],
    watch: {},
    computed: {

      // TODO: new style for v-model props
      // TODO: new hotness for v-model props
      localValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
      // start sticky /////////////////////////////////////////////////////
      // start sticky /////////////////////////////////////////////////////
      // start sticky /////////////////////////////////////////////////////
      property: function() {
        // console.log('property', this.stickyModelPathArray)
        return this.stickyModelPathArray
      },
      // end sticky /////////////////////////////////////////////////////
      // end sticky /////////////////////////////////////////////////////
      // end sticky /////////////////////////////////////////////////////

      // start dynamic blackout /////////////////////////////////////////////////////
      // start dynamic blackout /////////////////////////////////////////////////////
      // start dynamic blackout /////////////////////////////////////////////////////
      computedOldest: function() {
        // console.log('computedOldest ///////////////////////////////////////////////')
        // console.log('computedOldest this.items', this.items)

        let sortedArray = this.computedOrderedItems
        // console.log('computedOldest sortedArray', sortedArray)

        let row = first(sortedArray)
        // console.log('computedOldest row', row)

        if (!row) return
        let datetime = row[this.datetimeProperty]
        // let datetime = row.datetime
        console.log('===================================== bookends computedOldest datetime', datetime)

        return datetime
      },
      computedNewest: function() {
        // console.log('bookends computedNewest')
        let sortedArray = this.computedOrderedItems
        console.log('bookends computedNewest sortedArray', sortedArray)

        let row = last(sortedArray)
        console.log('bookends computedNewest row', row)

        if (!row) return
        let datetime = row[this.datetimeProperty]
        // let datetime = row.datetime
        // console.log('bookends computedNewest datetime', datetime)

        console.log('===================================== bookends computedNewest datetime', datetime)
        return datetime
      },
      // end dynamic blackout /////////////////////////////////////////////////////
      // end dynamic blackout /////////////////////////////////////////////////////
      // end dynamic blackout /////////////////////////////////////////////////////
      computedPlaceholder: function() {
        // console.log('///////////////////////////////////// start computedPlaceholder')
        let placeholder = this.placeholder
        // let placeholderFunc = this.placeholderFunc
        // let placeholderItems = this.placeholderItems

        // console.log('computedPlaceholder placeholder', placeholder)

        let items = this.items

        if (items?.length) {
          // console.log('computedPlaceholder items', items)

          const startDatetime = this.computedOldest
          // const startDatetime = this.oldest()
          // console.log('computedPlaceholder items startDatetime', startDatetime)

          const endDatetime = this.computedNewest
          // const endDatetime = this.newest()
          // console.log('computedPlaceholder items endDatetime', endDatetime)

          placeholder = this.getRangeString(startDatetime, endDatetime)
        }
        // console.log('computedPlaceholder placeholder', placeholder)
        // console.log('===================================== end computedPlaceholder')

        return placeholder
      },
      computedOrderedItems: function() {
        // console.log('bookends computedOrderedItems!')

        let items = this.items
        items = items.filter(object => {
          return object[this.datetimeProperty] !== null && object[this.datetimeProperty] !== undefined
        })
        console.log('bookends computedOrderedItems datetimeProperty', this.datetimeProperty)
        let sortedArray = orderBy(items, [ this.datetimeProperty ], [ 'asc' ])
        // let sortedArray = orderBy(items, [ 'datetime' ], [ 'asc' ])
        return sortedArray
      },
    },
    methods: {
      // start sticky /////////////////////////////////////////////////////
      // start sticky /////////////////////////////////////////////////////
      // start sticky /////////////////////////////////////////////////////
      rangePickerDidChange: function(datetimeArray) {
        // console.log('rangePickerDidChange datetimeArray', datetimeArray)

        let cleanedDatetimeArray = compact(datetimeArray)

        if (cleanedDatetimeArray.length === 0) {
          // console.log('rangePickerDidChange cleanedDatetimeArray.length === 0')

          cleanedDatetimeArray = null
          this.localValue = null

        }

        if (this.sticky) {
          // console.log('rangePickerDidChange sticky', this.sticky)
          this.setDiscriminatorProperty(cleanedDatetimeArray)
        }
      },
      // end sticky /////////////////////////////////////////////////////
      // end sticky /////////////////////////////////////////////////////
      // end sticky /////////////////////////////////////////////////////

      // start dynamic blackout /////////////////////////////////////////////////////
      // start dynamic blackout /////////////////////////////////////////////////////
      // start dynamic blackout /////////////////////////////////////////////////////
      getRangeString: function(startDatetime, endDatetime) {
        const parameters = {
          startDatetime: startDatetime,
          endDatetime: endDatetime,
        }
        const datetimeString = this.datetimeRangeStringFormat(parameters)
        return datetimeString
      },
      datetimeRangeStringFormat: function(parameters) {
        const formatString = 'MM/dd/yy, hh:mm aaa'
        const startDatetime = parameters.startDatetime
        const endDatetime = parameters.endDatetime

        let retVal = ''
        if (startDatetime && endDatetime) {
          const formatStartDatetime = helpers.formatDatetime(startDatetime, formatString)
          const formatEndDatetime = helpers.formatDatetime(endDatetime, formatString)

          retVal = `${ formatStartDatetime } to ${ formatEndDatetime }`

        }

        return retVal
      },

      // end dynamic blackout /////////////////////////////////////////////////////
      // end dynamic blackout /////////////////////////////////////////////////////
      // end dynamic blackout /////////////////////////////////////////////////////
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .success {
    border-color: #1d7c66 !important;
    background-color: #1d7c66 !important;
  }
</style>
